export const createWaterPurchaseRequestId = () => {
  if (typeof window !== "undefined" && typeof window.crypto?.randomUUID === "function") {
    return window.crypto.randomUUID()
  }
  return `water-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
}
export const getStableWaterPurchaseRequest = (
  currentRequest,
  payload,
  createRequestId = createWaterPurchaseRequestId,
) => {
  const fingerprint = JSON.stringify(payload || {})
  if (currentRequest?.fingerprint === fingerprint && currentRequest?.requestId) {
    return currentRequest
  }
  return { fingerprint, requestId: createRequestId() }
}
